export default {"src":"/_next/static/media/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};